import { GoDotFill, GoPlus } from "react-icons/go";
import { Button, InputField } from "../../../../components/forms";
import { nodept } from "../../../../constant/import";
import useLeaveHook from "../../../../hooks/useLeaveHook";
import PositionItem from "../PositionItem";
import LeaveTypeITem from "./LeaveTypeITem";
import { Fragment, useEffect, useState } from "react";
import { FaCalendar } from "react-icons/fa";
import { BsPersonFillDash } from "react-icons/bs";
import { Menu, Transition } from "@headlessui/react";
import { CiEdit } from "react-icons/ci";
import { FiFileMinus } from "react-icons/fi";
import { IoMdEye, IoMdMore } from "react-icons/io";
import { MdCancel, MdDelete, MdOutlineCancel, MdOutlineInfo } from "react-icons/md";
import ContracctDetails from "../ContracctDetails";
import { LuUser } from "react-icons/lu";
import usePositionHook from "../../../../hooks/usePositionHook";
import useDepartmentHook from "../../../../hooks/useDepartmentHook";
import { useStateSetter } from "../../../../hooks/statehooks/UseStateSettersHook";
import { useForm } from "react-hook-form";

export default ({ setshowaddleavemodal,isAdminview, leaves,  refresh }: any) => {
  const EmptyList = () => (
    <div className=" mx-6 p-5 scale-[.75]   text-textbg flex flex-col justify-center rounded-xl items-center border border-gray-300 ">
      <img src={nodept} />
      <p className="font-bold">No Leave requests</p>
      <small>No leave requests yet</small>

      <Button
        width={200}
        disabled={false}
        text={
          <>
            <GoPlus size={15} className=" mx-1 inline" /> Add leave request
          </>
        }
        onBtnClick={() => {
          setshowaddleavemodal(true);
        }}
      />
    </div>
  );

  return (
    <div className="w-full">
      <div>
        {leaves.length > 0 ? (
           <div className="grid grid-cols-2 gap-2">
            {  !isAdminview ?leaves.map((item: any) => (
              <LeaveItem item={item} refresh={refresh} />
            )):
            leaves.map((item: any) => (
              <LeaveItem2 item={item} refresh={refresh} />
            ))
            }
          </div> 
        ) : (<EmptyList />)}
      </div>
    </div>
  );
};

const LeaveItem = ({ item, refresh }: any) => {
  const [startdate, setstartdate] = useState("");
  const [enddate, setenddate] = useState("");
  const { selectedOrgDepts } = useDepartmentHook();
  const { allorgPositions } = usePositionHook();
  const { CancelLeave } = useLeaveHook();
  const { showModal, setShowModal } = useStateSetter();

  useEffect(() => {
    var enddate_ = new Date(item.endDate);
    var statdate_ = new Date(item.startDate);
    setenddate(enddate_.toDateString());
    setstartdate(statdate_.toDateString());
  }, []);

  const todatestring = (datestring: string) => {
    var date = new Date(datestring);

    return date.toDateString();
  };
  function getduration() {
    var date1 = new Date(item.startDate);
    var date2 = new Date(item.endDate);

    const timeDifference = date2.getTime() - date1.getTime(); // Difference in milliseconds
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24); // Convert to day
    return Math.round(daysDifference);
  }

  const ViewLeaveModal = () => {
    return (
      <div className="flex flex-col justify-start w-full items-start">
        <p className="font-semibold w-full flex justify-between text-sm">
          Leave Request
          <MdOutlineCancel
            onClick={() => {
              setShowModal(false);
            }}
            size={20}
            className="text-gray-400"
          />
        </p>
        <p className="text-sm w-full my-2">
          {" "}
          <GoDotFill
            size={15}
            className={`${
              item.status == "pending" || item.status == "rejected"
                ? "text-[#F79009]"
                : ""
            }  ${item.status == "approved" ? "text-green-400" : ""} inline `}
          />
          {item.status}
        </p>
        {item.status != "pending" && (
          <p className="w-full flex  flex-col text-xs">
            <span className="font-medium ">Reason</span>
            <span className="font-light rounded mt-2 bg-gray-100 p-2">
              Note:{item.actionedComment}{" "}
            </span>
          </p>
        )}
        <div className="flex mt-2 flex-col w-full">
          <LuUser
            className="  p-2 rounded-full bg-faintBlue  text-textbg"
            size={50}
          />
          <div className="m-2">
            <p className="font-semibold text-sm">
              {item.employee.firstName} {item.employee.lastName}
            </p>
            <p className="font-light text-xs">{item.employee.workEmail} </p>
            <p className="font-light   ">
              <span className="bg-faint text-xs mx-1 rounded">
                {
                  allorgPositions.filter(
                    (ik: any) => ik.id == item.employee.positionID
                  )[0]?.positionTitle
                }
              </span>

              <span className="bg-faint text-xs mx-1 rounded">
                {" "}
                {
                  selectedOrgDepts.filter(
                    (ik: any) => ik.id == item.employee.deptID
                  )[0]?.deptName
                }
              </span>
            </p>
          </div>
          <div className="p-3 bg-gray-100 px-4 w-full rounded">
            <p className="w-full flex justify-between text-xs">
              <span className="font-medium ">Leave type</span>
              <span className="font-medium">{item.leaveType.leaveName}</span>
            </p>
            <p className="w-full flex justify-between text-xs">
              <span className="font-medium ">Start Date</span>
              <span className="font-medium">
                {todatestring(item.startDate)}
              </span>
            </p>
            <p className="w-full flex justify-between text-xs">
              <span className="font-medium ">End Date</span>
              <span className="font-medium">{todatestring(item.endDate)}</span>
            </p>
            <p className="w-full flex justify-between text-xs">
              <span className="font-medium ">Duration</span>
              <span className="font-medium">{getduration()} day(s)</span>
            </p>
            <p className="w-full flex  flex-col text-xs">
              <span className="font-medium ">Note</span>
              <span className="font-light rounded mt-2 bg-white p-2">
                Note:{item.reason}{" "}
              </span>
            </p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className=" px-2 py-4 text-xs  rounded-[10px] border border-gray-300  flex justify-between ">
      <p className="flex justify-center text-gray-600 items-center text-[10px]">
        <FaCalendar size={10} className="  inline" />
        {startdate}-{enddate}{" "}
        <BsPersonFillDash size={10} className=" inline mx-1" />
        {item.leaveType.leaveName}{" "}
        <GoDotFill
          size={15}
          className={`${
            item.status == "pending" || item.status == "rejected"
              ? "text-[#F79009] mx-1"
              : ""
          }  ${item.status == "approved" ? "text-green-400" : ""} inline `}
        />
        {item.status}
      </p>
      <Menu as="div" className={`relative my-2 `}>
        <Menu.Button className="   w-full       ">
          <IoMdMore size={20} className="text-textbg " />
        </Menu.Button>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items
            onClick={() => {}}
            className="origin-top-left z-10 absolute left-0 mt-2 rounded-sm shadow-md p-1 bg-white w-full  max-h-[200px] min-w-[150px]   overflow-x-hidden overflow-y-scroll ring-1 ring-black ring-opacity-5 focus:outline-none"
          >
            <Menu.Item>
              <p
                onClick={() => {
                  showModal("", "", <></>, <ViewLeaveModal />);
                }}
                className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
              >
                <IoMdEye className="inline" /> View
              </p>
            </Menu.Item>
            <Menu.Item>
              <p
                onClick={async () => {
                  await CancelLeave(item.id);
                  refresh()
                }}
                className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
              >
                <MdCancel className="inline" /> Cancel
              </p>
            </Menu.Item>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};

const todatestring = (datestring: string) => {
  var date = new Date(datestring);

  return date.toDateString();
};

const LeaveItem2 = ({ item, refresh }: any) => {
  const [startdate, setstartdate] = useState("");
  const { showModal, setShowModal } = useStateSetter();
  const [enddate, setenddate] = useState("");
  const { selectedOrgDepts } = useDepartmentHook();
  const { control, getValues } = useForm();
  const { RejectLeave, ApproveLeave } = useLeaveHook();
  const { allorgPositions } = usePositionHook();
  useEffect(() => {
    var enddate_ = new Date(item.endDate);
    var statdate_ = new Date(item.startDate);

    setenddate(enddate_.toDateString());
    setstartdate(statdate_.toDateString());
  }, []);
  function getduration() {
    var date1 = new Date(item.startDate);
    var date2 = new Date(item.endDate);

    const timeDifference = date2.getTime() - date1.getTime(); // Difference in milliseconds
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24); // Convert to day
    return Math.round(daysDifference);
  }

  const RejectLeaveModal = () => {
    return (
      <div className="flex flex-col justify-center w-full items-center">
        <MdOutlineInfo size={30} className="text-primary my-2" />

        <p className="font-semibold"> Reject Leave Request </p>
        <small className="font-light text-gray-500   text-center">
          You are about to reject this leave request. Please leave a note
          explaining the reason for the rejection.
        </small>
        <div className="w-full">
          <InputField
            name="reason"
            title="Reason"
            placeholder={"Reason for rejection"}
            isTextArea
            control={control}
          />
        </div>

        <div className=" gap-6 w-full flex ">
          <Button
            outlined
            disabled={false}
            text="Cancel"
            onBtnClick={() => {
              setShowModal(false);
            }}
          />
          <Button
            disabled={false}
            text="Reject"
            onBtnClick={async () => {
              await RejectLeave(item.id, getValues("reason"));
              refresh()
            }}
          />
        </div>
      </div>
    );
  };

  const ViewLeaveModal = () => {
    return (
      <div className="flex flex-col justify-start w-full items-start">
        <p className="font-semibold w-full flex justify-between text-sm">
          Leave Request
          <MdOutlineCancel
            onClick={() => setShowModal(false)}
            size={20}
            className="text-gray-400"
          />
        </p>
        <p className="text-sm w-full my-2">
          {" "}
          <GoDotFill
            size={15}
            className={`${
              item.status == "pending" || item.status == "rejected"
                ? "text-[#F79009]"
                : ""
            }  ${item.status == "approved" ? "text-green-400" : ""} inline `}
          />
          {item.status}
        </p>

        {item.status != "pending" && (
          <p className="w-full flex  flex-col text-xs">
            <span className="font-medium ">Reason</span>
            <span className="font-light rounded mt-2 bg-gray-100 p-2">
              Note:{item.actionedComment}{" "}
            </span>
          </p>
        )}
        <div className="flex mt-2 flex-col w-full">
          <LuUser
            className="  p-2 rounded-full bg-faintBlue  text-textbg"
            size={50}
          />{" "}
          <div className="m-2">
            <p className="font-semibold text-sm">
              {item.employee.firstName} {item.employee.lastName}
            </p>
            <p className="font-light text-xs">{item.employee.workEmail} </p>
            <p className="font-light   ">
              <span className="bg-faint text-xs mx-1 rounded">
                {" "}
                {
                  allorgPositions.filter(
                    (ik: any) => ik.id == item.employee.positionID
                  )[0]?.positionTitle
                }
              </span>

              <span className="bg-faint text-xs mx-1 rounded">
                {" "}
                {
                  selectedOrgDepts.filter(
                    (ik: any) => ik.id == item.employee.deptID
                  )[0]?.deptName
                }
              </span>
            </p>
          </div>
          <div className="p-3 bg-gray-100 px-4 w-full rounded">
            <p className="w-full flex justify-between text-xs">
              <span className="font-medium ">Leave type</span>
              <span className="font-medium">{item.leaveType.leaveName}</span>
            </p>
            <p className="w-full flex justify-between text-xs">
              <span className="font-medium ">Start Date</span>
              <span className="font-medium">
                {todatestring(item.startDate)}
              </span>
            </p>
            <p className="w-full flex justify-between text-xs">
              <span className="font-medium ">End Date</span>
              <span className="font-medium">{todatestring(item.endDate)}</span>
            </p>
            <p className="w-full flex justify-between text-xs">
              <span className="font-medium ">Duration</span>
              <span className="font-medium">{getduration()} day(s)</span>
            </p>
            <p className="w-full flex  flex-col text-xs">
              <span className="font-medium ">Note</span>
              <span className="font-light rounded mt-2 bg-white p-2">
                Note:{item.reason}{" "}
              </span>
            </p>
          </div>
          {item.status == "pending" ? (
            <div className=" gap-6 w-full flex ">
              <Button
                outlined
                disabled={false}
                text="Reject"
                onBtnClick={async () => {
                  showModal("", "", <></>, <RejectLeaveModal />);
                }}
              />
              <Button
                disabled={false}
                text="Approve"
                onBtnClick={async () => {
                  await ApproveLeave(item.id);
                  refresh()

                }}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  };

  return (
    <div className=" px-2 py-6 text-xs  rounded-[10px] border border-gray-300  flex justify-between ">
      <div>
        <p className="font-semibold my-2 ">
          {item.employee.firstName} {item.employee.lastName}
        </p>
        <p className="flex justify-center text-gray-600 items-center text-[10px]">
          <FaCalendar size={10} className="  inline" />
          {startdate}-{enddate}{" "}
          <BsPersonFillDash size={10} className=" inline" />
          {item.leaveType.leaveName}{" "}
          <GoDotFill
            size={15}
            className={`${
              item.status == "pending" || item.status == "rejected"
                ? "text-[#F79009]"
                : ""
            }  ${item.status == "approved" ? "text-green-400" : ""} inline `}
          />
          {item.status}
        </p>
      </div>
      <Menu as="div" className={`relative my-2 `}>
        <Menu.Button className="   w-full       ">
          <IoMdMore size={20} className="text-textbg " />
        </Menu.Button>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items
            onClick={() => {}}
            className="origin-top-left z-10 absolute left-0 mt-2 rounded-sm shadow-md p-1 bg-white w-full  max-h-[200px] min-w-[150px]   overflow-x-hidden overflow-y-scroll ring-1 ring-black ring-opacity-5 focus:outline-none"
          >
            <Menu.Item>
              <p
                onClick={() => {
                  showModal("", "", <></>, <ViewLeaveModal />);
                }}
                className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
              >
                <IoMdEye className="inline" /> View
              </p>
            </Menu.Item>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};